import * as PropTypes from 'prop-types';

//SingleBillDetails ("BeautifulBill") section props (Charges, Adjustments, etc.)

export const SingleBillChargesGroups = PropTypes.arrayOf(
  PropTypes.shape({
    title: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        description: PropTypes.string.isRequired,
        amount: PropTypes.number.isRequired
      })
    )
  })
);

export const SingleBillDetailsSection = {
  title: PropTypes.string.isRequired,
  totalAmount: PropTypes.number.isRequired,
  chargesGroups: SingleBillChargesGroups,
  testId: PropTypes.string
};
